/*
 *
 * Users Actions
 *
 * @version 1.0.0
 * @author Andrea Pinardi
 * @since 08-Jan-2025
 */

import { createRequestTypes, createAction, MakeRequest } from 'Store/actions/index'

export const actionTypes = {
  DO_FETCH_USERS: '@@Users/fetch_users',
  DO_CREATE_OR_UPDATE_USER: '@@Users/create_or_update_user',
  // @generator action:route:type
  ...createRequestTypes('@@Users', 'GET_USERS'),
  ...createRequestTypes('@@Users', 'CREATE_OR_UPDATE_USER')
  // @generator action:route:type:request
}

// ------------------------------------
// Actions
// ------------------------------------
// @generator action:route:request
/** @action request
 * * Insert a description
 * @name createOrUpdateUser
 * @return {object} - The action object
 */
export const createOrUpdateUser = new MakeRequest('Users', 'create_or_update_user')
/** @action request
 * * Insert a description
 * @name getUsers
 * @return {object} - The action object
 */
export const getUsers = new MakeRequest('Users', 'get_users')
// @generator action:route
/** @action
 * * Insert a description
 * @name CreateOrUpdateUser
 * @return {object} - The payload object
 */
export const doCreateOrUpdateUser = (payload) => createAction(actionTypes.DO_CREATE_OR_UPDATE_USER, { payload })
/** @action
 * * Insert a description
 * @name FetchUsers
 * @return {object} - The payload object
 */
export const doFetchUsers = (payload) => createAction(actionTypes.DO_FETCH_USERS, { payload })
